import index from "./admin.vue";
export default index;
